// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PlaceOrderFooterFbCmp from "./PlaceOrderFooterFbCmp.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var locationLine = PlaceOrderAssetsManager.getImage("location-line.svg");

function ConfirmOrderFbCmp(Props) {
  return React.createElement("div", {
              className: "confirm_order_fallback"
            }, React.createElement("div", {
                  className: "section__container"
                }, React.createElement("p", {
                      className: "title"
                    }, "PICK UP AND DROP"), React.createElement("div", {
                      className: "content__container"
                    }, React.createElement("img", {
                          className: "map-marker",
                          src: locationLine
                        }), React.createElement("div", {
                          className: "address-cards"
                        }, React.createElement("div", {
                              className: "loading-shimmer"
                            }), React.createElement("div", {
                              className: "loading-shimmer"
                            })))), React.createElement("div", {
                  className: "vehicle loading-shimmer"
                }), React.createElement("p", {
                  className: "payment_label"
                }, "Payment Summary"), React.createElement("div", {
                  className: "paymnet_summary"
                }, React.createElement("div", {
                      className: "tile "
                    }, React.createElement("p", {
                          className: "loading-shimmer"
                        }), React.createElement("p", {
                          className: "loading-shimmer"
                        })), React.createElement("div", {
                      className: "tile "
                    }, React.createElement("p", {
                          className: "loading-shimmer"
                        }), React.createElement("p", {
                          className: "loading-shimmer"
                        })), React.createElement("div", {
                      className: "tile "
                    }, React.createElement("p", {
                          className: "loading-shimmer"
                        }), React.createElement("p", {
                          className: "loading-shimmer"
                        })), React.createElement("div", {
                      className: "tile total"
                    }, React.createElement("p", {
                          className: "loading-shimmer"
                        }), React.createElement("p", {
                          className: "loading-shimmer"
                        }))), React.createElement(PlaceOrderFooterFbCmp.make, {}));
}

var make = ConfirmOrderFbCmp;

export {
  locationLine ,
  make ,
  
}
/* locationLine Not a pure module */
